module.exports = __webpack_public_path__ + "img/dush.38c21292.svg";